export type ResolvedImage =
  | { kind: 'screenshot'; key: string }
  | { kind: 'url'; src: string };

export const SCREENSHOT_PREFIX = 'screenshot:';

export function resolveImage(src: string): ResolvedImage {
  const value = (src ?? '').trim();
  if (value.startsWith(SCREENSHOT_PREFIX)) {
    return { kind: 'screenshot', key: value.slice(SCREENSHOT_PREFIX.length) };
  }
  return { kind: 'url', src: value };
}
